import * as XLSX from 'xlsx';
import {
  mapRecordToExportRow,
  buildExportFilename
} from './liveUrlTrackingExportUtils';

export const exportTrackingRecordsToExcel = (records = [], filters = {}) => {
  if (!Array.isArray(records) || records.length === 0) {
    return;
  }

  const excelData = records.map((record) => mapRecordToExportRow(record));
  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Live URL Tracking');
  XLSX.writeFile(workbook, buildExportFilename(filters));
};
